<template>
    <div v-wechat-title="title">
    <div class="work-schedule">
        <div class="header">
            <h1 class="title">麻醉护理排班表</h1>
            <div>
                <el-button type="primary" size="small" :style="{ borderRadius: '4px' }" v-if="activeSchedule && activeSchedule.status == 1" @click="save(1)">保存</el-button>
                <el-button type="primary" size="small" :style="{ borderRadius: '4px' }" v-if="activeSchedule && activeSchedule.status == 1" @click="save(2)">发布</el-button>
                <el-button type="primary" size="small" :style="{ borderRadius: '4px' }" v-if="activeSchedule && activeSchedule.status == 2" @click="unlock(1)">解锁</el-button>
            </div>
            <div class="flex">
                <el-button icon="el-icon-back" type="primary" plain circle @click="addDate(-1)" size="small"
                    style="padding: 10px !important;margin-right: 10px;"></el-button>
                <h2 class="date">{{ nowDate }}</h2>
                <el-button icon="el-icon-right" type="primary" plain circle @click="addDate(1)"
                    style="padding: 10px !important;margin-left: 10px"></el-button>
                <h2 class="date">{{ nowWeekday }}</h2>
            </div>
        </div>
<div class="content" :style="{pointerEvents: activeSchedule && activeSchedule.status == 1 ?'auto':'none'}">
    <div class="table-wrapper">
        <table>
            <tr @click="showUserGroup">
                <td :colspan="2" class="td_bg"></td>
                <td class="thead td_bg" :colspan="5">
                    <h2>恢复室</h2>
                </td>
            </tr>
            <template
                v-for="(item, index) in wardArr">
                <tr :key="index+'_'+'morning'" class="tr_h">
                    <td class="cursor-pointer td_bg" :rowspan="4" @click="showUserGroup">
                        <h2>{{item.dic_ward_name}}</h2>
                    </td>
                    <td class="text-xl theme-text" @click="showUserGroup">早</td>
                    <td v-for="cellIdx in 5" :key="'morning'+'_'+cellIdx"
                        @click="setActiveItem('恢复室',item.dic_ward_name,'早',cellIdx)"
                        :class="{ td_active:isActive('恢复室',item.dic_ward_name,'早',cellIdx)}"
                        >
                        <div v-if="getTableCellData('恢复室',item.dic_ward_name,'早',cellIdx)"
                            class="cell flex justify-center items-center fontsz"
                            :style="{ backgroundColor: `rgb(${getCellItem('恢复室',item.dic_ward_name,'早',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                            @dblclick="delSchedule('恢复室',item.dic_ward_name,'早',cellIdx)">
                            {{getTableCellData('恢复室',item.dic_ward_name,'早',cellIdx)}}
                        </div>
                    </td>
                </tr>
                <tr :key="index+'_'+'noon'" class="tr_h">
                    <td class="text-xl theme-text" @click="showUserGroup">中</td>
                    <td v-for="cellIdx in 5" :key="'noon'+'_'+cellIdx"
                        @click="setActiveItem('恢复室',item.dic_ward_name,'中',cellIdx)"
                        :class="{ td_active:isActive('恢复室',item.dic_ward_name,'中',cellIdx)}">
                        <div v-if="getTableCellData('恢复室',item.dic_ward_name,'中',cellIdx)"
                            class="cell flex justify-center items-center fontsz"
                            :style="{ backgroundColor: `rgb(${getCellItem('恢复室',item.dic_ward_name,'中',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                            @dblclick="delSchedule('恢复室',item.dic_ward_name,'中',cellIdx)">
                            {{getTableCellData('恢复室',item.dic_ward_name,'中',cellIdx)}}
                        </div>
                    </td>
                </tr>
                <tr :key="index+'_'+'evening'" class="tr_h">
                    <td class="text-xl theme-text" @click="showUserGroup">晚</td>
                    <td v-for="cellIdx in 5" :key="'evening'+'_'+cellIdx"
                        @click="setActiveItem('恢复室',item.dic_ward_name,'晚',cellIdx)"
                        :class="{ td_active:isActive('恢复室',item.dic_ward_name,'晚',cellIdx)}">
                        <div v-if="getTableCellData('恢复室',item.dic_ward_name,'晚',cellIdx)"
                            class="cell flex justify-center items-center fontsz"
                            :style="{ backgroundColor: `rgb(${getCellItem('恢复室',item.dic_ward_name,'晚',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                            @dblclick="delSchedule('恢复室',item.dic_ward_name,'晚',cellIdx)">
                            {{getTableCellData('恢复室',item.dic_ward_name,'晚',cellIdx)}}
                        </div>
                    </td>
                </tr>
                <tr :key="index+'_'+'remark'" class="tr_h">
                    <td class="text-xl theme-text" @click="showUserGroup">备注</td>
                    <!-- <td v-for="cellIdx in 5" :key="'remark'+'_'+cellIdx"
                        @click="setActiveItem('恢复室',item.dic_ward_name,'备注',cellIdx)"
                        :class="{ td_active:isActive('恢复室',item.dic_ward_name,'备注',cellIdx)}">
                        <div v-if="getTableCellData('恢复室',item.dic_ward_name,'备注',cellIdx)"
                            class="cell flex justify-center items-center fontsz">
                            <div>{{getTableCellData('恢复室',item.dic_ward_name,'备注',cellIdx)}}</div>
                        </div>
                    </td> -->
                    <td v-for="cellIdx in 5" :key="'remark'+'_'+cellIdx">
                        <el-input class="centered-input" v-model="item.hfsArr[cellIdx-1]" />
                    </td>
                </tr>
            </template>
        </table>

        <table>
            <tr style="height: 50px;">
                <td class="thead td_bg" :colspan="4">
                    <h2>麻护</h2>
                </td>
                <td class="right-cell td_bg"><h2>听班</h2></td>
                <!-- <td class="right-cell" :rowspan="9">
                    <div class="cell flex flex-col p-1">
                        <div class="flex-1 flex flex-col gap-1 items-center">
                            <div class="text-xl">听班</div>
                            <div style="width:100%;height:32px;" class="flex justify-center" @click="setActiveItem('听班','','',1)"
                            :class="{ td_active:isActive('听班','','',1)}" @dblclick="delSchedule('听班','','',1)">
                                <div v-if="getTableCellData('听班','','',1)" :style="{ backgroundColor: `rgb(${getCellItem('听班','','',1).back_color})` }">{{getTableCellData('听班','','',1)}}</div>
                            </div>
                            <div style="width:100%;height:32px;" class="flex justify-center" @click="setActiveItem('听班','','',2)"
                                :class="{ td_active:isActive('听班','','',2)}" @dblclick="delSchedule('听班','','',2)">
                                <div v-if="getTableCellData('听班','','',2)" :style="{ backgroundColor: `rgb(${getCellItem('听班','','',2).back_color})` }">{{getTableCellData('听班','','',2)}}</div>
                            </div>
                            <div style="width:100%;height:32px;" class="flex justify-center" @click="setActiveItem('听班','','',3)"
                                :class="{ td_active:isActive('听班','','',3)}" @dblclick="delSchedule('听班','','',3)">
                                <div v-if="getTableCellData('听班','','',3)" :style="{ backgroundColor: `rgb(${getCellItem('听班','','',3).back_color})` }">{{getTableCellData('听班','','',3)}}</div>
                            </div>
                        </div>
                        <div class="flex-1 flex flex-col gap-1">
                            <div class="text-xl">电话</div>
                            <el-input v-if="activeSchedule" v-model="activeSchedule.telephone"/>
                        </div>
                    </div>
                </td> -->
            </tr>
            <template
                v-for="(item, index) in wardArr">
                <tr :key="index+'_'+'morning'" class="tr_h">
                    <td v-for="cellIdx in 4" :key="'morning'+'_'+cellIdx"
                        @click="setActiveItem('麻护',item.dic_ward_name,'早',cellIdx)"
                        :class="{ td_active:isActive('麻护',item.dic_ward_name,'早',cellIdx)}">
                        <div v-if="getTableCellData('麻护',item.dic_ward_name,'早',cellIdx)"
                            class="cell flex justify-center items-center fontsz"
                            :style="{ backgroundColor: `rgb(${getCellItem('麻护',item.dic_ward_name,'早',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                            @dblclick="delSchedule('麻护',item.dic_ward_name,'早',cellIdx)">
                            {{getTableCellData('麻护',item.dic_ward_name,'早',cellIdx)}}
                        </div>
                    </td>
                    <!-- <td class="right-cell" v-if="item.dic_ward_name === '一区'"
                            @click="setActiveItem('听班','','',1)"
                            :class="{ td_active:isActive('听班','','',1)}"
                            @dblclick="delSchedule('听班','','',1)">
                            <div v-if="getTableCellData('听班','','',1)"
                            class="cell flex justify-center items-center fontsz"
                            :style="{ backgroundColor: `rgb(${getCellItem('听班','','',1).back_color})` }">
                                {{getTableCellData('听班','','',1)}}</div>
                    </td> -->
                    <td class="right-cell" v-if="item.dic_ward_name === '一区'">
                        <el-input class="centered-input" v-model="tbArr[0]" />
                    </td>
                    <td class="right-cell td_bg" v-if="item.dic_ward_name === '二三区'">
                        <h2>电话</h2>
                    </td>
                    <td class="right-cell td_bg" v-if="item.dic_ward_name === '四区'">
                        <h2>通知</h2>
                    </td>
                    <!-- <td class="right-cell" :rowspan="8" v-if="item.dic_ward_name === '四区' && index+'_'+'morning'=='2_morning'">
                        <div class="cell flex flex-col p-1 gap-1">
                            <div class="text-xl">通知</div>
                            <el-input v-if="activeSchedule" type="textarea" v-model="activeSchedule.notice" class="textarea"></el-input>
                        </div>
                    </td> -->
                </tr>
                <tr :key="index+'_'+'noon'" class="tr_h">
                    <td v-for="cellIdx in 4" :key="'noon'+'_'+cellIdx" @click="setActiveItem('麻护',item.dic_ward_name,'中',cellIdx)"
                        :class="{ td_active:isActive('麻护',item.dic_ward_name,'中',cellIdx)}">
                        <div v-if="getTableCellData('麻护',item.dic_ward_name,'中',cellIdx)"
                            class="cell flex justify-center items-center fontsz"
                            :style="{ backgroundColor: `rgb(${getCellItem('麻护',item.dic_ward_name,'中',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                            @dblclick="delSchedule('麻护',item.dic_ward_name,'中',cellIdx)">
                            {{getTableCellData('麻护',item.dic_ward_name,'中',cellIdx)}}
                        </div>
                    </td>
                    <!-- <td class="right-cell" v-if="item.dic_ward_name === '一区'"
                    @click="setActiveItem('听班','','',2)"
                    :class="{ td_active:isActive('听班','','',2)}"
                    @dblclick="delSchedule('听班','','',2)">
                            <div v-if="getTableCellData('听班','','',2)" class="cell flex justify-center items-center fontsz"
                                :style="{ backgroundColor: `rgb(${getCellItem('听班','','',2).back_color})` }">
                                {{getTableCellData('听班','','',2)}}</div>
                    </td> -->
                    <td class="right-cell" v-if="item.dic_ward_name === '一区'">
                        <el-input class="centered-input" v-model="tbArr[1]" />
                    </td>
                    <td class="right-cell tr_h" v-if="item.dic_ward_name === '二三区'">
                        <el-input class="centered-input" v-if="activeSchedule" v-model="activeSchedule.telephone" />
                    </td>
                    <td class="right-cell" rowspan="7" v-if="item.dic_ward_name === '四区'">
                        <el-input v-if="activeSchedule" type="textarea" rows="7" v-model="activeSchedule.notice" class="textarea"></el-input>
                    </td>
                </tr>
                <tr :key="index+'_'+'evening'" class="tr_h">
                    <td v-for="cellIdx in 4" :key="'evening'+'_'+cellIdx"
                        @click="setActiveItem('麻护',item.dic_ward_name,'晚',cellIdx)"
                        :class="{ td_active:isActive('麻护',item.dic_ward_name,'晚',cellIdx)}">
                        <div v-if="getTableCellData('麻护',item.dic_ward_name,'晚',cellIdx)"
                            class="cell flex justify-center items-center fontsz"
                            :style="{ backgroundColor: `rgb(${getCellItem('麻护',item.dic_ward_name,'晚',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                            @dblclick="delSchedule('麻护',item.dic_ward_name,'晚',cellIdx)">
                            {{getTableCellData('麻护',item.dic_ward_name,'晚',cellIdx)}}
                        </div>
                    </td>
                    <!-- <td class="right-cell" v-if="item.dic_ward_name === '一区'"
                    @click="setActiveItem('听班','','',3)"
                    :class="{ td_active:isActive('听班','','',3)}"
                    @dblclick="delSchedule('听班','','',3)">
                    <div v-if="getTableCellData('听班','','',3)" class="cell flex justify-center items-center fontsz"
                        :style="{ backgroundColor: `rgb(${getCellItem('听班','','',3).back_color})` }">
                        {{getTableCellData('听班','','',3)}}</div>
                </td> -->
                    <td class="right-cell" v-if="item.dic_ward_name === '一区'">
                        <el-input class="centered-input" v-model="tbArr[2]" />
                    </td>
                <td class="right-cell" v-if="item.dic_ward_name === '二三区'">
                </td>
                </tr>
                <tr :key="index+'_'+'remark'" class="tr_h">
                    <!-- <td v-for="cellIdx in 4" :key="'remark'+'_'+cellIdx"
                        @click="setActiveItem('麻护',item.dic_ward_name,'备注',cellIdx)"
                        :class="{ td_active:isActive('麻护',item.dic_ward_name,'备注',cellIdx)}">
                        <div v-if="getTableCellData('麻护',item.dic_ward_name,'备注',cellIdx)"
                            class="cell flex justify-center items-center fontsz"
                            @dblclick="delSchedule('麻护',item.dic_ward_name,'备注',cellIdx)">
                            <div>{{getTableCellData('麻护',item.dic_ward_name,'备注',cellIdx)}}</div>
                        </div>
                    </td> -->
                    <td v-for="cellIdx in 4" :key="'remark'+'_'+cellIdx">
                        <el-input class="centered-input" v-model="item.mhArr[cellIdx-1]" />
                    </td>
                    <!-- <td class="right-cell" v-if="item.dic_ward_name === '一区'" @click="setActiveItem('听班','','',4)"
                        :class="{ td_active:isActive('听班','','',4)}" @dblclick="delSchedule('听班','','',4)">
                    <div v-if="getTableCellData('听班','','',4)" class="cell flex justify-center items-center fontsz"
                        :style="{ backgroundColor: `rgb(${getCellItem('听班','','',4).back_color})` }">
                        {{getTableCellData('听班','','',4)}}</div>
                    </td> -->
                    <td class="right-cell" v-if="item.dic_ward_name === '一区'">
                        <el-input class="centered-input" v-model="tbArr[3]" />
                    </td>
                    <td class="right-cell" v-if="item.dic_ward_name === '二三区'">
                    </td>
                </tr>
            </template>
        </table>
        <table>
            <tr class="tr_bottom_h">
                <td class="td_bg" :rowspan="4"></td>
                <td class="text-xl td_bg" :colspan="3">
                    <div class="cell flex justify-center items-center fontsz" @click="showUserGroup">总务</div>
                </td>
                <td class="text-xl td_bg" :colspan="2">
                    <div class="cell flex justify-center items-center fontsz" @click="showUserGroup">胃肠镜</div>
                </td>
                <td class="text-xl td_bg">
                    <div class="cell flex justify-center items-center fontsz" @click="showUserGroup">公出</div>
                </td>
            </tr>
            <tr class="tr_bottom_h">
                <td>
                    <div class="cell text-xl flex justify-center items-center theme-text">
                        早
                    </div>
                </td>
                <td v-for="cellIdx in 2" :key="'zw'+'_'+cellIdx" @click="setActiveItem('总务','','早',cellIdx)"
                    :class="{ td_active:isActive('总务','','早',cellIdx)}">
                    <div v-if="getTableCellData('总务','','早',cellIdx)"
                    :style="{ backgroundColor: `rgb(${getCellItem('总务','','早',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                    class="cell flex justify-center items-center fontsz"
                        @dblclick="delSchedule('总务','','早',cellIdx)">{{getTableCellData('总务','','早',cellIdx)}}
                    </div>
                </td>
                <td>
                    <div class="cell text-xl flex justify-center items-center theme-text">
                        治疗
                    </div>
                </td>
                <td @click="setActiveItem('胃肠镜','','治疗',1)" :class="{ td_active:isActive('胃肠镜','','治疗',1)}">
                    <div v-if="getTableCellData('胃肠镜','','治疗',1)"
                    :style="{ backgroundColor: `rgb(${getCellItem('胃肠镜','','治疗',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                    class="cell flex justify-center items-center fontsz"
                        @dblclick="delSchedule('胃肠镜','','治疗',1)">
                        {{getTableCellData('胃肠镜','','治疗',1)}}
                    </div>
                </td>
                <td @click="setActiveItem('公出','','治疗',1)" :class="{ td_active:isActive('公出','','治疗',1)}">
                    <div v-if="getTableCellData('公出','','治疗',1)"
                    class="cell flex justify-center items-center fontsz"
                    :style="{ backgroundColor: `rgb(${getCellItem('公出','','治疗',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule('公出','','治疗',1)">{{getTableCellData('公出','','治疗',1)}}
                    </div>
                </td>
            </tr>
            <tr class="tr_bottom_h">
                <td></td>
                <td v-for="cellIdx in 2" :key="'zw_noon'+'_'+cellIdx" @click="setActiveItem('总务','','',cellIdx)"
                    :class="{ td_active:isActive('总务','','',cellIdx)}">
                    <div v-if="getTableCellData('总务','','',cellIdx)"
                        class="cell flex justify-center items-center fontsz"
                        :style="{ backgroundColor: `rgb(${getCellItem('总务','','',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule('总务','','',cellIdx)">
                        {{getTableCellData('总务','','',cellIdx)}}
                    </div>
                </td>
                <td>
                    <div class="cell text-xl flex justify-center items-center theme-text">
                        检查1
                    </div>
                </td>
                <td @click="setActiveItem('胃肠镜','','检查1',1)" :class="{ td_active:isActive('胃肠镜','','检查1',1)}">
                    <div v-if="getTableCellData('胃肠镜','','检查1',1)"
                        class="cell flex justify-center items-center fontsz"
                        :style="{ backgroundColor: `rgb(${getCellItem('胃肠镜','','检查1',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule('胃肠镜','','检查1',1)">
                        {{getTableCellData('胃肠镜','','检查1',1)}}
                    </div>
                </td>
                <td @click="setActiveItem('公出','','检查1',1)" :class="{ td_active:isActive('公出','','检查1',1)}">
                    <div v-if="getTableCellData('公出','','检查1',1)"
                        :style="{ backgroundColor: `rgb(${getCellItem('公出','','检查1',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        class="cell flex justify-center items-center fontsz"
                        @dblclick="delSchedule('公出','','检查1',1)">
                        {{getTableCellData('公出','','检查1',1)}}
                    </div>
                </td>
            </tr>
            <tr class="tr_bottom_h">
                <td>
                    <div class="cell text-xl flex justify-center items-center theme-text">
                        晚
                    </div>
                </td>
                <td v-for="cellIdx in 2" :key="'zw'+'_'+cellIdx" @click="setActiveItem('总务','','晚',cellIdx)"
                    :class="{ td_active:isActive('总务','','晚',cellIdx)}">
                    <div v-if="getTableCellData('总务','','晚',cellIdx)"
                        :style="{ backgroundColor: `rgb(${getCellItem('总务','','晚',cellIdx).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        class="cell flex justify-center items-center fontsz"
                        @dblclick="delSchedule('总务','','晚',cellIdx)">
                        {{getTableCellData('总务','','晚',cellIdx)}}
                    </div>
                </td>
                <td>
                    <div class="cell text-xl flex justify-center items-center theme-text">
                        检查2
                    </div>
                </td>
                <td @click="setActiveItem('胃肠镜','','检查2',1)" :class="{ td_active:isActive('胃肠镜','','检查2',1)}">
                    <div v-if="getTableCellData('胃肠镜','','检查2',1)"
                        :style="{ backgroundColor: `rgb(${getCellItem('胃肠镜','','检查2',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        class="cell flex justify-center items-center fontsz"
                        @dblclick="delSchedule('胃肠镜','','检查2',1)">
                        {{getTableCellData('胃肠镜','','检查2',1)}}
                    </div>
                </td>
                <td @click="setActiveItem('公出','','检查2',1)" :class="{ td_active:isActive('公出','','检查2',1)}">
                    <div v-if="getTableCellData('公出','','检查2',1)"
                    :style="{ backgroundColor: `rgb(${getCellItem('公出','','检查2',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        class="cell flex justify-center items-center fontsz"
                        @dblclick="delSchedule('公出','','检查2',1)">
                        {{getTableCellData('公出','','检查2',1)}}
                    </div>
                </td>
            </tr>
        </table>

        <table>
            <tr class="tr_bottom_h">
                <td class="text-xl td_bg" @click="showUserGroup">轮转</td>
                <td class="text-xl td_bg" @click="showUserGroup">休假</td>
                <td class="text-xl td_bg" @click="showUserGroup">产假</td>
                <td class="text-xl td_bg" @click="showUserGroup">病假</td>
                <td class="text-xl right-cell td_bg" :colspan="2" @click="showUserGroup">卫生员</td>
            </tr>
            <tr class="tr_bottom_h">
                <td v-for="name in ['轮转','休假','产假','病假']" :key="'morning'+'_'+name" @click="setActiveItem(name,'','早',1)" :class="{ td_active:isActive(name,'','早',1)}">
                    <div v-if="getTableCellData(name,'','早',1)"
                        class="cell flex justify-center items-center fontsz"
                        :style="{ backgroundColor: `rgb(${getCellItem(name,'','早',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule(name,'','早',1)">
                        {{getTableCellData(name,'','早',1)}}
                    </div>
                </td>
                <td class="text-xl theme-text">早 <span class="text-sm">(医疗)</span></td>
                <td @click="setActiveItem('卫生员','','早',1)" :class="{ td_active:isActive('卫生员','','早',1)}">
                    <div v-if="getTableCellData('卫生员','','早',1)"
                    class="cell flex justify-center items-center fontsz"
                    :style="{ backgroundColor: `rgb(${getCellItem('卫生员','','早',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule('卫生员','','早',1)">
                        {{getTableCellData('卫生员','','早',1)}}
                    </div>
                </td>
            </tr>
            <tr class="tr_bottom_h">
                <td v-for="name in ['轮转','休假','产假','病假']" :key="'noon'+'_'+name" @click="setActiveItem(name,'','',1)"
                    :class="{ td_active:isActive(name,'','',1)}">
                    <div v-if="getTableCellData(name,'','',1)"
                    class="cell flex justify-center items-center fontsz"
                    :style="{ backgroundColor: `rgb(${getCellItem(name,'','',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule(name,'','',1)">{{getTableCellData(name,'','',1)}}
                    </div>
                </td>
                <td class="text-xl theme-text">早 <span class="text-sm">(外科)</span></td>
                <td @click="setActiveItem('卫生员','','早外科',1)" :class="{ td_active:isActive('卫生员','','早外科',1)}">
                    <div v-if="getTableCellData('卫生员','','早外科',1)"
                    class="cell flex justify-center items-center fontsz"
                    :style="{ backgroundColor: `rgb(${getCellItem('卫生员','','早外科',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule('卫生员','','早外科',1)">
                        {{getTableCellData('卫生员','','早外科',1)}}
                    </div>
                </td>
            </tr>
            <tr class="tr_bottom_h">
                <td v-for="name in ['轮转','休假','产假','病假']" :key="'afternoon'+'_'+name" @click="setActiveItem(name,'','晚',1)"
                    :class="{ td_active:isActive(name,'','晚',1)}">
                    <div v-if="getTableCellData(name,'','晚',1)"
                    class="cell flex justify-center items-center fontsz"
                    :style="{ backgroundColor: `rgb(${getCellItem(name,'','晚',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule(name,'','晚',1)">
                    {{getTableCellData(name,'','晚',1)}}
                    </div>
                </td>
                <td class="text-xl theme-text">晚</td>
                <td @click="setActiveItem('卫生员','','晚',1)" :class="{ td_active:isActive('卫生员','','晚',1)}">
                    <div v-if="getTableCellData('卫生员','','晚',1)"
                    class="cell flex justify-center items-center fontsz"
                    :style="{ backgroundColor: `rgb(${getCellItem('卫生员','','晚',1).back_color})`, color:`black !importent`, border: `0.1px solid black` }"
                        @dblclick="delSchedule('卫生员','','晚',1)">
                        {{getTableCellData('卫生员','','晚',1)}}
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>
<div v-drag="dialogLoction" class="user_box" v-show="!isHide">
    <div class="userlisttitle">
        <i class="el-icon-user-solid"></i>
        人员列表
    </div>
    <el-scrollbar :style="{ height: `${this.screenHeight - 300}px`}">
        <el-menu :unique-opened="false" :default-openeds="openeds">
            <template v-for="g in schedule_userGroup">
                <el-submenu :index="g.id.toString()" :key="g.id" style="padding: 0 0px !important" class="submenu_user">
                    <div slot="title" style="padding: 0 0px; font-size: 16px">
                        <h1 style="text-align: left; padding: 0px 30px 0px 5px; margin: 8px 0px 8px 0px">
                            {{ g.name }}<span class="fg-info">({{ (g.users && g.users.length) || 0
                                }})</span>
                            <!-- <i class="el-icon-edit" @click.stop="editUserGroup(g)"></i>-->
                        </h1>
                    </div>
                    <div v-if="g.users && g.users.length > 0">
                        <template v-for="d in g.users">
                            <div class="user" :key="d.worker_id" @click="selectUser(d, g.back_color, g.is_multi_duty)"
                                :style="{'backgroundColor' : `rgb(${g.back_color})`}">
                                <span>{{
                                    d.worker_name
                                    }}</span>
                            </div>
                        </template>
                    </div>
                </el-submenu>
            </template>
        </el-menu>
    </el-scrollbar>
</div>
    </div>
    <el-dialog ref="form_unlock" title="解锁" :close-on-click-modal="true"
        :visible.sync="alterPasswordDialog.dialogFormVisible" width="30%">
        <el-row>
            <el-input v-model="alterPasswordDialog.data.uid" ref="uid" :clearable="true" :autofocus="true">
                <template slot="prepend">
                    <i class="el-icon-user"></i>
                </template>
            </el-input>
        </el-row>
        <el-row>
            <el-input v-model="alterPasswordDialog.data.pwd" ref="pwd" show-password :clearable="true">
                <template slot="prepend">
                    <i class="el-icon-lock"></i>
                </template>
            </el-input>
        </el-row>
        <el-row slot="footer" class="dialog-footer">
            <el-button @click="alterPasswordDialog.dialogFormVisible = false" icon="el-icon-unlock">取 消</el-button>
            <el-button type="primary" @click="saveLock(1)" icon="el-icon-unlock">确 定</el-button>
        </el-row>
    </el-dialog>
    </div>
</template>
<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
    name: `UnLoginRecoverySchedule`,
    props: {},
    data() {
        return {
            title: `复苏室排班`,
            token: this.$route.query.token,
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            nowWeekday: [`星期日`, `星期一`, `星期二`, `星期三`, `星期四`, `星期五`, `星期六`][moment().day()],
            scheduleTableDatas: [],
            o_active_item: null,
            active_item: [null, null, null, null], // 1:type,2:wardname,3:datepart,4:displayorder
            dialogLoction: {
                top: 0,
                right: 0,
                width: `50%`,
                height: `450px`
            },
            isHide: true,
            userGroupForm: {
                dialogFormVisible: false,
                workerReadonly: false,
                firstOpen: true,
                workerinfo: {},
                userGroup: []
            },
            schedule_userGroup: [],
            schedule_userGroup_bak: [],
            workerList: [],
            scheduleDate: this.$moment().format(`YYYY-MM-DD`),
            activeScheduleId: 0,
            activeSchedule: null,
            alterPasswordDialog: {
                title: `解锁`,
                dialogFormVisible: false,
                data: {
                    uid: ``,
                    pwd: ``,
                    exp: 100000
                }
            },
            wardArr: [{ 'dic_ward_name': `一区`, hfsArr: [``, ``, ``, ``, ``], mhArr: [``, ``, ``, ``] },
                { 'dic_ward_name': `二三区`, hfsArr: [``, ``, ``, ``, ``], mhArr: [``, ``, ``, ``] },
                { 'dic_ward_name': `四区`, hfsArr: [``, ``, ``, ``, ``], mhArr: [``, ``, ``, ``] },
                { 'dic_ward_name': `五区`, hfsArr: [``, ``, ``, ``, ``], mhArr: [``, ``, ``, ``] }],
            tbArr: [``, ``, ``, ``]
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        // this.loadToken().then(() => {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.init()
        })
        // })
    },
    mounted() {},
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`, `sysuser/workers_by_duty`, `currentUser`, `sysuser/workers`, `active_ward`, `section_auth`, `ward_auth`]),
        nowDate() {
            return this.$moment(this.scheduleDate).format(`YYYY年MM月DD日`)
        },
        getTableCellData() {
            let that = this
            return function(type, wardname, datepart, displayorder) {
                let item = _.find(
                    that.scheduleTableDatas,
                    x => x.type == type &&
                        x.ward_name == wardname &&
                        x.date_part == datepart &&
                        x.display_order == displayorder
                )
                return item && item.worker_name || ``
            }
        },
        getCellItem() {
            let that = this
            return function(type, wardname, datepart, displayorder) {
                let item = _.find(
                    that.scheduleTableDatas,
                    x => x.type == type &&
                        x.ward_name == wardname &&
                        x.date_part == datepart &&
                        x.display_order == displayorder
                )
                return item || null
            }
        },
        isActive() {
            let that = this
            return function(type, wardname, datepart, displayorder) {
                return that.active_item[0] == type &&
                    that.active_item[1] == wardname &&
                    that.active_item[2] == datepart &&
                    that.active_item[3] == displayorder
            }
        },
        openeds() {
            return this.schedule_userGroup.map(i => i.id.toString())
        }
    },
    methods: {
        loadToken() {
            return new Promise(resolve => {
                if (this.newuser) {
                    this.user = decodeURIComponent(window.atob(this.newuser))
                }
                let username = this.user.split(`|`)[0]
                let password = this.user.split(`|`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    sessionStorage.setItem(`token`, data)
                    resolve(data)
                })
            })
        },
        loadDateSchedule() {
            let that = this
            return new Promise(resolve => {
                that.active_item = [null, null, null, null]
                let req = that.myaxios.get(`/api/AcisSystem/RecoverySchedule/GetRecoveryScheduleByDate?scheduleDate=${this.scheduleDate}`)
                req.then(data => {
                    if (data) {
                        that.activeScheduleId = data.id
                        that.activeSchedule = data
                    } else {
                        that.activeSchedule = {
                            id: 0,
                            name: ``,
                            schedule_date: that.scheduleDate,
                            status: 1,
                            status_name: `未发布`,
                            telephone: ``,
                            notice: ``
                        }
                        that.activeScheduleId = 0
                        // that.scheduleTableDatas = [] //这里特地
                    }
                    resolve(that.activeScheduleId)
                })
            })
        },
        loadRecoveryScheduleData(activeScheduleId) {
            let that = this
            return new Promise(resolve => {
                this.active_item = [null, null, null, null]
                let req = this.myaxios.get(`/api/AcisSystem/RecoveryScheduleDetail/GetRecoveryScheduleDetails?biz_recoveryschedule_id=${this.activeScheduleId}`)
                req.then(data => {
                    if (data) {
                        that.scheduleTableDatas = data
                        _.forEach(data, item => {
                            if (item.type == `听班`) {
                                that.tbArr[item.display_order - 1] = item.worker_name
                            } else if (item.date_part == `备注` && (item.type == `恢复室` || item.type == `麻护`)) {
                                let fieldName = item.type == `恢复室` ? `hfsArr` : `mhArr`
                                let wardIndex = ``
                                switch (item.ward_name) {
                                case `一区`:
                                    wardIndex = 0
                                    break
                                case `二三区`:
                                    wardIndex = 1
                                    break
                                case `四区`:
                                    wardIndex = 2
                                    break
                                case `五区`:
                                    wardIndex = 3
                                    break
                                }
                                that.wardArr[wardIndex][fieldName][item.display_order - 1] = item.worker_name
                            }
                        })
                    }
                    resolve(data)
                })
            })
        },
        showUserGroup() {
            console.log(123)
            this.isHide = !this.isHide
        },
        selectUser(user, backColor, isMultiDuty) {
            let that = this
            if (that.activeSchedule.status == 2) {
                that.$message.error(`排班已发布,请取消发布后再设置`)
                this.active_item = [null, null, null, null]
                return
            }

            let newresultWorker = {
                biz_recovery_schedule_id: that.activeScheduleId,
                worker_name: user.worker_name,
                worker_id: user.worker_id,
                back_color: backColor // 使用组的颜色
            }
            // 选中了哪个区域
            if (that.active_item[0] !== null && that.active_item[1] !== null && that.active_item[2] !== null) {
                this.$set(newresultWorker, `type`, this.active_item[0])
                this.$set(newresultWorker, `ward_name`, this.active_item[1])
                this.$set(newresultWorker, `date_part`, this.active_item[2])
                this.$set(newresultWorker, `display_order`, this.active_item[3])
                let item = _.find(
                    this.scheduleTableDatas,
                    x =>
                        x.type == newresultWorker.type &&
                        x.ward_name == newresultWorker.ward_name &&
                        x.date_part == newresultWorker.date_part &&
                        x.display_order == newresultWorker.display_order
                )
                if (item) {
                    // 找到了 替换
                    this.$set(item, `worker_id`, newresultWorker.worker_id)
                    this.$set(item, `worker_name`, newresultWorker.worker_name)
                    this.$set(item, `back_color`, newresultWorker.back_color)
                } else {
                    // 没找到了 加
                    this.$set(this.scheduleTableDatas, this.scheduleTableDatas.length, newresultWorker)
                }
                that.changeUserGroup()
            }
            this.$forceUpdate()
        },
        setActiveItem(type, wardname, datepart, displayorder) {
            if (this.active_item[0] == type && this.active_item[1] == wardname && this.active_item[2] == datepart && this.active_item[3] == displayorder) {
                // 选择状态下取消选中
                this.active_item = [null, null, null, null]
                // 1:type,2:wardname,3:datepart,4:displayorder
            } else {
                this.active_item = [type, wardname, datepart, displayorder]
                // 1:type,2:wardname,3:datepart,4:displayorder
            }
        },
        // 调用搜狗输入法
        handlerSoGoInput() {
            window.location.href = `Handinput://test`
        },
        // 关闭搜狗手写输入法
        closeSoGoInput() {
            // eslint-disable-next-line
            let cmd = new ActiveXObject(`WScript.Shell`)
            cmd.run(`taskkill /f /t /im handinput.exe`, 0)
        },
        loadShiftUserGroup(activeScheduleId) {
            let that = this
            that.schedule_userGroup = []
            return new Promise(resolve => {
                // 获取排班表设置的用户组
                let req = this.myaxios.get(`/api/AcisSystem/ShiftUserGroup/GetUserGroupByScheduleId?scheduleId=${activeScheduleId}`)
                req.then(data => {
                    that.schedule_userGroup = data
                    that.workerList = []
                    that.userGroupForm.userGroup = []
                    _.forEach(this.schedule_userGroup, item => {
                        item.users &&
                            _.forEach(item.users, user => {
                                if (user.worker_id > 0) {
                                    that.workerList.push({
                                        worker_name: user.worker_name,
                                        worker_id: user.worker_id,
                                        worker_code: user.worker_section_name,
                                        back_color: item.back_color || `255,255,255`, // 按组设置背景色，不按人员
                                        shift_user_group_id: item.id
                                    })
                                }
                            })
                        that.userGroupForm.userGroup.push({
                            label: item.name,
                            value: parseInt(item.id)
                        })
                    })
                    that.schedule_userGroup_bak = _.cloneDeep(that.schedule_userGroup)
                    that.changeUserGroup()
                    resolve(that.schedule_userGroup)
                })
            })
        },
        save(publish) {
            let that = this
            that.saveMain(publish).then(data => {
                that.saveDetail(publish)
            })
        },
        saveMain(publish) {
            let that = this
            return new Promise(resolve => {
                that.activeSchedule.status = publish
                this.myaxios[that.activeSchedule.id > 0 ? `put` : `post`](`/api/AcisSystem/RecoverySchedule/${that.activeSchedule.id > 0 ? `Put` : `Post`}`, that.activeSchedule)
                    .then(data => {
                        that.activeScheduleId = data.id
                        that.activeSchedule = data
                        that.scheduleTableDatas.forEach(detail => {
                            detail.biz_recovery_schedule_id = that.activeScheduleId
                        })
                        resolve(that.activeSchedule)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$message.error(e.data.detail)
                    })
            })
        },
        saveDetail(publish) {
            let that = this
            let tableData = _.filter(that.scheduleTableDatas, (d) => {
                return d.type != `听班` && d.date_part != `备注`
            })
            // let otherData = []
            that.tbArr && _.forEach(that.tbArr, (tb, index) => {
                if (tb) {
                    tableData.push({
                        biz_recovery_schedule_id: that.activeScheduleId,
                        type: `听班`,
                        worker_name: tb,
                        display_order: index + 1,
                        back_color: `255,255,255` // 按组设置背景色，不按人员
                    })
                }
            })
            that.wardArr && _.forEach(that.wardArr, (ward, index) => {
                ward && ward.hfsArr && _.forEach(ward.hfsArr, (hfs, index) => {
                    if (hfs) {
                        tableData.push({
                            biz_recovery_schedule_id: that.activeScheduleId,
                            type: `恢复室`,
                            ward_name: ward.dic_ward_name,
                            date_part: `备注`,
                            worker_name: hfs,
                            display_order: index + 1,
                            back_color: `255,255,255` // 按组设置背景色，不按人员
                        })
                    }
                })
                ward && ward.mhArr && _.forEach(ward.mhArr, (mh, index) => {
                    if (mh) {
                        tableData.push({
                            biz_recovery_schedule_id: that.activeScheduleId,
                            type: `麻护`,
                            ward_name: ward.dic_ward_name,
                            date_part: `备注`,
                            worker_name: mh,
                            display_order: index + 1,
                            back_color: `255,255,255` // 按组设置背景色，不按人员
                        })
                    }
                })
            })
            console.log(`tableData`, tableData)
            let url = `/api/AcisSystem/RecoveryScheduleDetail/DeleteAndPost?bizRecoveryScheduleId=${that.activeScheduleId}`
            var reps = this.myaxios.post(url, tableData)
            reps.then(data => {
                // 自动保存不用提示,按钮保存提示
                this.loadRecoveryScheduleData(that.activeScheduleId)
                this.isHide = true
                that.$message.success(`${publish == 2 ? `发布成功` : `保存成功`}`)
            })
        },
        delSchedule(type, wardname, datepart, displayorder) {
            let that = this
            let itemIndex = _.findIndex(
                that.scheduleTableDatas,
                x => x.biz_recovery_schedule_id == that.activeScheduleId &&
                    x.type == type &&
                    x.ward_name == wardname &&
                    x.date_part == datepart &&
                    x.display_order == displayorder
            )
            if (itemIndex >= 0) {
                that.scheduleTableDatas.splice(itemIndex, 1)
                that.changeUserGroup()
            }
        },
        changeUserGroup() {
            let that = this
            let workIds = _.map(that.scheduleTableDatas, d => d.worker_id)
            workIds = _.filter(workIds, (d) => {
                return d > 0
            })
            let groupUser = _.cloneDeep(that.schedule_userGroup_bak)
            that.schedule_userGroup = groupUser && _.forEach(groupUser, group => {
                if (group && !group.is_multi_duty) { // 非多次排班
                    group.users = _.filter(group.users, (d) => {
                        return !_.includes(workIds, d.worker_id)
                    })
                }
            }) || []
        },
        unlock(status) {
            this.alterPasswordDialog.data.uid = this.currentUser.username
            this.alterPasswordDialog.data.pwd = null
            this.alterPasswordDialog.dialogFormVisible = true
        },
        saveLock(publish) {
            if (!this.alterPasswordDialog.data.uid || !this.alterPasswordDialog.data.pwd) {
                this.$message.error(`请输入用户名或密码`)
                return
            }
            let user = Object.assign({}, this.alterPasswordDialog.data)
            if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                let encryptor = new JSEncrypt()
                encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                user.pwd = encryptor.encrypt(user.pwd)
            }
            this.myaxios
                .post(`api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: user
                })
                .then(data => {
                    if (this.activeScheduleId > 0) {
                        this.save(publish)
                    }
                    this.alterPasswordDialog.dialogFormVisible = false
                })
        },
        addDate(prevOrNext) {
            let that = this
            let d = that.$moment(that.scheduleDate).subtract(-prevOrNext, `days`).format(`YYYY-MM-DD`)
            that.scheduleDate = d
        },
        init() {
            this.loadDateSchedule().then(activeScheduleId => {
                if (activeScheduleId > 0) {
                    this.loadRecoveryScheduleData(activeScheduleId).then(() => {
                        // 这个屏幕是301 特定的，-1 就表示301 复苏屏，不用改动
                        this.loadShiftUserGroup(-1)
                    })
                } else {
                    // 这个屏幕是301 特定的，-1 就表示301 复苏屏，不用改动
                    this.loadShiftUserGroup(-1)
                }
            })
        }
    },
    watch: {
        scheduleDate: function(newVlaue, oldValue) {
            this.init()
        },
        active_item: function(newvalue, oldval) {
            if (oldval && newvalue && (oldval[0] != null && oldval[3] != null) && (newvalue[0] != null && newvalue[3] != null)) {
                this.o_active_item = oldval
                // oldcellItem =null 表示点击了空的单元格，先单击空的单元格，在点击 一个 有人的单元格，则完成人员调换
                let oldcellItem = this.getCellItem(oldval[0], oldval[1], oldval[2], oldval[3])
                let newcellItem = this.getCellItem(newvalue[0], newvalue[1], newvalue[2], newvalue[3])
                if (!oldcellItem && newcellItem) {
                    this.$set(newcellItem, `type`, oldval[0])
                    this.$set(newcellItem, `ward_name`, oldval[1])
                    this.$set(newcellItem, `date_part`, oldval[2])
                    this.$set(newcellItem, `display_order`, oldval[3])
                }
            }
        }
        // this.active_item = [type, wardname, datepart, displayorder]
    }
}
</script>
<style scoped lang="less">
.centered-input /deep/ .el-input__inner {
  text-align: center;
}
h1,
h2,
h3,
h4,
h5 {
    margin: 0;
}
.work-schedule {
    --table-border-color: #e5e5e5;
    --table-thead-height: 50px;
    --table-gap: 10px;
    --theme-color: var(--primary-color, #009688);
    --grid-fr: calc((100% - var(--table-thead-height) * 2 - var(--table-gap)) / 5);
    .theme-text {
        color: var(--theme-color);
    }
    .text-xs {
        font-size: 12px;
    }
    .text-sm {
        font-size: 16px;
    }
    .text-base {
        font-size: 16px;
    }
    .text-lg {
        font-size: 18px;
    }
    .text-xl {
        font-size: 20px;
    }
    .td_active {
        border: 2px solid orange !important;
    }
    .text-2xl {
        font-size: 24px;
    }
    .font-bold {
        font-weight: bold;
    }
    .flex {
        display: flex;
    }
    .justify-center {
        justify-content: center;
    }
    .items-center {
        align-items: center;
    }
    .fontsz {
        font-size: 20px;
    }
    .flex-col {
        flex-direction: column;
    }
    .flex-1 {
        flex: 1;
    }
    .gap-1 {
        gap: 4px;
    }
    .p-1 {
        padding: 4px;
    }
    .p-2 {
        padding: 8px;
    }
    .p-3 {
        padding: 12px;
    }
    .w-full {
        width: 100%;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    display: flex;
    flex-direction: column;
    height: 100vh;
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        height: 60px;
        .title {
            color: #ff8800;
        }
        .date {
            color: #ff8800;
        }
    }
    .content {
        flex: 1;
        height: 0;
        //color: var(--theme-color);
        padding: var(--table-gap);
        .table-wrapper {
            height: 100%;
            display: grid;
            grid-template-columns: 5fr 4fr;
            grid-template-rows:
                calc(var(--grid-fr) * 4 + var(--table-thead-height))
                calc(var(--grid-fr) + var(--table-thead-height));
            gap: var(--table-gap);
            table {
                width: 100%;
                table-layout: fixed;
                /* border-collapse: collapse; */
                border-collapse: separate;
                border-spacing: 0px;
                border-width: 1px;
                border-color: var(--table-border-color);
                word-break: break-all;
                .tr_h{
                    height: calc((100vh - 50px - 196px - 60px - 20px - 10px) / 16);
                }
                .tr_h /deep/ .el-input__inner{
                     height: 32px;
                     line-height: 32px;
                     font-size: 20px;
                }
                .tr_bottom_h{
                    height: 40px;
                }
                td,
                th {
                    border-width: 1px;
                    border-style: solid;
                    text-align: center;
                    border-color: var(--table-border-color);
                    box-sizing: border-box;
                    position: relative;
                    //   padding: 2px;
                    .cell {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                    }
                    .tag {
                        color: #fff;
                        background-color: orange;
                        padding: 2px 12px;
                        border-radius: 4px;
                        width: fit-content;
                        font-size: 20px;
                    }
                }
                .thead {
                    height: var(--table-thead-height);
                }
                .right-cell {
                    width: 35%;
                    .textarea {
                        flex: 1;
                        font-size: 20px;
                    }
                }
                .td_bg{
                    background: var(--primary-color, #009688);
                    color:#ffffff;
                }
            }
        }
    }
    .user_box{
            border: 2px solid #ebeef5;
            width: 200px;
            float: left;
            position: absolute;
            top: 120px;
            right: 100px;
            z-index: 1000;
            .userlisttitle {
                height: 50px;
                line-height: 50px;
                font-size: 20px;
                font-weight: bold;
                text-align: left;
                padding-left: 20px;
                border-bottom: 2px solid #ebeef5;
                background: var(--primary-color, #009688);
                color: #fff;
            }
            .submenu_user {
                .user {
                    min-width: 100px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin: 2px 5px 5px 5px;
                    border: solid 1px;
                    border-radius: 3px;
                    cursor: move;
                    font-size: 20px;
                    color: #2c3e50 !important;
                    height: 50px;
                    line-height: 50px;
                    padding: 0 45px;
                }
                .user:hover {
                    outline: 0;
                    background-color: var(--primary-light, #e6f5f3) !important;
                }
            }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ScheduleShift/UnLoginRecoverySchedule.vue